import { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import {
  CAJACHICA_ASIGNAR_DOCUMENTOS,
  CAJACHICA_ASIGNAR_DOCUMENTOS_TRABAJADORES,
  CAJACHICA_REGISTRAR_TRABAJADORES_LISTA,
  CAJACHICA_REGISTRAR_TRABAJADORES_NUEVO,
  CAJACHICA_TRABAJADOR_VIATICO
} from 'constants/codigosTransacciones'

import AsignarDocumentosPage from './asignarDocumentos'
import asignarDocumentosTrabajadores from './asignarDocumentosTrabajadores'
import RegistrarTrabajadoresPage from './registrarTrabajadores'
import TrabajadorTituloViaticoPage from './trabajadorTituloViatico'

export default function CajaChicaPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${CAJACHICA_ASIGNAR_DOCUMENTOS}`} component={AsignarDocumentosPage} />
        <Route path={`/${CAJACHICA_ASIGNAR_DOCUMENTOS_TRABAJADORES}`} component={asignarDocumentosTrabajadores} />
        <Route path={`/${CAJACHICA_TRABAJADOR_VIATICO}`} component={TrabajadorTituloViaticoPage} />
        <Route path={`/${CAJACHICA_REGISTRAR_TRABAJADORES_LISTA}`} component={RegistrarTrabajadoresPage} />
        <Route path={`/${CAJACHICA_REGISTRAR_TRABAJADORES_NUEVO}`} component={RegistrarTrabajadoresPage} />
        <Route path={`/${CAJACHICA_REGISTRAR_TRABAJADORES_NUEVO}/:id`} component={RegistrarTrabajadoresPage} />
      </Switch>
    </Suspense>
  )
}
